import * as type from "../../types/trans";

export const PortfolioCall = (data) => {
  return {
    type: type.PORTFOLIO_DATA_PENDING,
    payload: data,
  };
};

export const PortfolioDataAllScheme = (data) => {
  console.log("PortfolioDataAllScheme",data);
  return {
    type: type.PORTFOLIO_ALL_DATA_PENDING,
    payload: data,
  };
};

export const FetchFundCategoryNew = (data) => {
  console.log("FetchFundCategoryNew",data);
  return {
    type: type.FUNDCATEGORYNEW_ALL_DATA_PENDING,
    payload: data,
  };
}

export const PortFolioBanner = (data) => {
  return {
    type: type.PORTFOLIO_BANNER,
    payload: data,
  };
}
export const portfolioRedirection = (data) => {
  return {
    type: type.PORTFOLIO_PAGE,
    payload: data,
  };
};
export const PortfolioMohCall = (data) => {
  return {
    type: type.PORTFOLIO_DATA_MOH,
    payload: data,
  };
};

export const newFundset = (data) => {
  return {
    type: type.NEW_FUND_SET,
    payload: data,
  };
};

export const newUserData = (data) => {
  return {
    type: type.NEW_USER_DATA,
    payload: data,
  };
};

export const OrderBook = (data) => {
  console.log("orderBookAction", data);
  return {
    type: type.ORDERBOOK_PENDING,
    payload: data,
  };
};

export const FolioDesc = (data) => {
  return {
    type: type.FOLIODESC_PENDING,
    payload: data,
  };
};

export const schemeFolioWiseData = (data) => {
  return {
    type: type.PORTFOLIO_SINGLE,
    payload: data,
  };
};

export const SchemeSingleSelect = (data) => {
  return {
    type: type.PORTFOLIO_SCHEME_CODE,
    payload: data,
  };
};

export const FolioSelect = (data) => {
  return {
    type: type.PORTFOLIO_FOLIO_CODE,
    payload: data,
  };
};
export const holdingTypeSelect = (data) => {
  return {
    type: type.PORTFOLIO_HOLDING_TYPE,
    payload: data,
  };
};

export const existingContainer = (data) => {
  return {
    type: type.EXISTING_BOX,
    payload: data,
  };
};

export const selectedBank = (bankName, bankAcc) => {
  return {
    type: type.PORTFOLIO_SELECTED_BANK,
    payload: { bankName, bankAcc },
  };
};

export const Purchase = (data) => {
  return {
    type: type.ADD_TO_CART_PENDING,
    payload: data,
  };
};

export const singleCartData = (data) => {
  return {
    type: type.SINGLE_CART_DATA,
    payload: data,
  };
};

export const getSipDashboard = (data) => {
  return {
    type: type.SIPDASHBOARD_PENDING,
    payload: data,
  };
};

export const getSwpDashboard = (data) => {
  return {
    type: type.SWPDASHBOARD_PENDING,
    payload: data,
  };
};

export const getStpDashboard = (data) => {
  return {
    type: type.STPDASHBOARD_PENDING,
    payload: data,
  };
};

export const fillFolioScheme = (data) => {
  console.log("fillFolioSchemeAction", data);

  return {
    type: type.PORTFOLIO_SCHEME_ACTION,
    payload: data,
  };
};

// CART ACTIONS
export const getCartData = (data) => {
  console.log("getCartData", data);
  return {
    type: type.GET_CART_PENDING,
    payload: data,
  };
};

export const getSipAmount = (data) => {
  return {
    type: type.SIP_AMOUNT,
    payload: data,
  };
};

export const getIsipChk = (data) => {
  return {
    type: type.ISIPCHK,
    payload: data,
  };
};

export const getisMandate = (data) => {
  return {
    type: type.ISMANDATE,
    payload: data,
  };
};
export const getisMandateAvail = (data) => {
  return {
    type: type.ISMANDATEAVAIL,
    payload: data,
  };
};

export const getisTwoPayment = (data) => {
  return {
    type: type.ISTWOPAYMENT,
    payload: data,
  };
};

export const getLumsumAmount = (data) => {
  return {
    type: type.LUM_AMOUNT,
    payload: data,
  };
};

export const getIsipAmount = (data) => {
  return {
    type: type.ISIP_AMOUNT,
    payload: data,
  };
};

export const getCartIdArray = (data) => {
  console.log("getCartIdArray----->", data);
  return {
    type: type.CART_ID,
    payload: data,
  };
};

export const getCART_ARRAY = (data) => {
  return {
    type: type.CART_ARRAY,
    payload: data,
  };
};

export const getBankName = (data) => {
  return {
    type: type.BANK_NAME,
    payload: data,
  };
};

export const getBankNumber = (data) => {
  return {
    type: type.BANK_NUMBER,
    payload: data,
  };
};

export const getBucketID = (data) => {
  return {
    type: type.BUCKET_ID,
    payload: data
  }
}

export const getPG = (data) => {
  return {
    type: type.PG,
    payload: data
  }
}

export const getIFSC = (data) => {
  return {
    type: type.IFSC,
    payload: data
  }
}

export const getRazorPayKey = (data) => {
  return {
    type: type.RAZORPAYKEY,
    payload: data
  }
}

export const getMandateName = (data) => {
  return {
    type: type.MANDATE_NAME,
    payload: data,
  };
};

export const getMandateNumber = (data) => {
  return {
    type: type.MANDATE_NUMBER,
    payload: data,
  };
};

export const getMandateIhno = (data) => {
  return {
    type: type.MANDATE_IHNO,
    payload: data,
  };
};

export const getChequeMode = (data) => {
  return {
    type: type.CHEQUE_MODE,
    payload: data,
  };
};

export const getPaymentMode = (data) => {
  return {
    type: type.PAYMENT_MODE,
    payload: data,
  };
};

export const getIsip = (data) => {
  return {
    type: type.ISIP_TYPE,
    payload: data,
  };
};

export const getLump = (data) => {
  return {
    type: type.LUMP_TYPE,
    payload: data,
  };
};

export const getSip = (data) => {
  return {
    type: type.SIP_TYPE,
    payload: data,
  };
};

export const resetPaymentMode = (data) => {
  return {
    type: type.RESET_PAYMENT_MODE,
  };
};

export const getUTRNo = (data) => {
  return {
    type: type.UTR_NO,
    payload: data,
  };
};

export const showBroker = (data) => {
  return {
    type: type.BROKER_CART_ID,
    payload: data,
  };
};

export const showDistBroker = (data) => {
  return {
    type: type.BROKER_DIS_CART_ID,
    payload: data,
  };
};

export const cartRowData = (data) => {
  return {
    type: type.CART_ROW_DATA,
    payload: data,
  };
};

export const saveDistReg = (data) => {
  return {
    type: type.PUSH_DIST_CARTID_REG_BROKER,
    payload: data,
  };
};

export const saveDistDir = (data) => {
  return {
    type: type.PUSH_DIST_CARTID_DIR_BROKER,
    payload: data,
  };
};

export const showBankErr = (data) => {
  return {
    type: type.SHOW_BANK_ERR,
    payload: data,
  };
};

export const showMandateErr = (data) => {
  return {
    type: type.SHOW_MANDATE_ERR,
    payload: data,
  };
};

export const showUtrNoErr = (data) => {
  return {
    type: type.SHOW_UTRNO_ERR,
    payload: data,
  };
};

export const updateGuestMenu = (data) => {
  return {
    type: type.UPDATE_GUEST_MENU,
    payload: data,
  };
};

export const setDistFlag = (data) => {
  return {
    type: type.SET_DIST_FLAG,
    payload: data,
  };
};

export const resetSipDashboard = (data) => {
  console.log("resetSipDashboard", resetSipDashboard);
  return {
    type: type.RESET_SIP_DASHBOARD,
  };
};

export const getAllFolios = () => {
  console.log("transAction getAllFolios");
  return {
    type: type.GET_ALL_FOLIOS,
  };
};

export const selectFolioCart = (data) => {
  console.log("selectFolioCart", data);
  return {
    type: type.PROCESS_FOLIOS_FOR_SELECT,
    payload: data,
  };
};

export const saveFolioHoldingData = (data) => {
  return {
    type: type.OB_FOLIOHOLDING_DATA,
    payload: data,
  };
};
export const foliolistKary = (data) => {
  return {
    type: type.FOLIO_KARY_PENDING,
    payload: data
  };
};


export const saveBucketId = (data) => {
  console.log("BucketID Get here", data)
  return {
    type: type.SAVE_BUCKET_ID,
    payload: data
  }
}

export const get_ALL_FUND_DETAILS = (data) => {
  return {
    type: type.ALL_FUND_DETAILS,
    payload: data,
  };
};